import './Localizacao.css';

export default function Localizacao() {
  return (
    <div className="localizacao-page">
      <div className="loc-header">
        <h1>📍 Localização</h1>
        <p>Venha nos visitar! Estamos esperando você.</p>
      </div>

      <div className="loc-content">
        <div className="loc-info">
          <div className="info-card">
            <h3>📍 Endereço</h3>
            <p>Rua da Pastelaria, 123</p>
            <p>Centro - Sua Cidade/UF</p>
            <p>CEP: 00000-000</p>
          </div>

          <div className="info-card">
            <h3>🕐 Horário de Funcionamento</h3>
            <div className="horario">
              <span>Segunda a Sexta</span>
              <strong>08:00 - 22:00</strong>
            </div>
            <div className="horario">
              <span>Sábado</span>
              <strong>08:00 - 23:00</strong>
            </div>
            <div className="horario">
              <span>Domingo</span>
              <strong>09:00 - 21:00</strong>
            </div>
          </div>

          <div className="info-card">
            <h3>🚗 Como chegar</h3>
            <p>Estamos localizados no centro da cidade, próximo à praça principal. Fácil acesso e estacionamento disponível.</p>
          </div>
        </div>

        <div className="loc-mapa">
          <div className="mapa-placeholder">
            <span>🗺️</span>
            <p>Mapa será exibido aqui</p>
            <small>Configure as coordenadas nas configurações do sistema</small>
          </div>
        </div>
      </div>
    </div>
  );
}
